export default __webpack_public_path__ + "static/media/digi3.8e57d3d4.png";